import { Component, OnInit } from '@angular/core';
import { EditProfileService } from '../profileedit/editprofile.service';
import { ROUTER_DIRECTIVES } from '@angular/router';
import { Router } from '@angular/router';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import { REACTIVE_FORM_DIRECTIVES, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ControlMessages } from '../../AuthModule/login-message.component';
import { ValidationService } from '../../AuthModule/login-validation.service';


declare const jQuery: any;

@Component({
  selector: 'profileedit',
  template: require('.//profile-edit.component.html'),
  directives: [ROUTER_DIRECTIVES, REACTIVE_FORM_DIRECTIVES, ControlMessages],
  providers: [EditProfileService]
})

export class ProfileeditComponent {


  private authorizedd1 = true;
  private authorizedd2 = true;
  private profileusername = false;
  private bufferprofile = false;

  private oldPassword: any;
  private newPassword: any;
  private confirmPassword: any;
  private passwordsuccess = true;
  private passworderror = true;
  private passwordolderror = true;
  private email_phone = false;
  private bio_details = false;
  private mobile_details = false;


  private data: any;
  private token: any;
  private loading = true;
  private saveuser = false;
  resetpasswordForm: any;
  saveprofileForm: any;
  websiteUrl: any;
  cloudinaryImage: any;

  // cloudinaryOptions: CloudinaryOptions = new CloudinaryOptions({
  //   cloud_name: 'picogram',
  //   upload_preset: 'uju4rpbl',
  //   autoUpload: true
  // });

  // profileImageuploader: CloudinaryUploader = new CloudinaryUploader(this.cloudinaryOptions);

  constructor(private _editprofileService: EditProfileService, private _router: Router, private formBuilder: FormBuilder) {

    this.resetpasswordForm = this.formBuilder.group({
      'oldPassword': ['', [Validators.required]],
      'newPassword': ['', [Validators.required]],
      'confirmPassword': ['', [Validators.required]]
    });

    // this.profileImageuploader.onSuccessItem = function (item: any, response: any, status: number, headers: any) {
    //   this.cloudinaryImage = JSON.parse(response);
    //    this.data.profilePicUrl = this.cloudinaryImage.url
    //   return { item, response, status, headers };
    // };
    // this.saveprofileForm = this.formBuilder.group({
    //        'fullName': ['', [Validators.required]],
    //        'username': ['', [Validators.required]], 
    //        'websiteUrl': ['', [Validators.required]],
    //        'bio': ['', [Validators.required]],
    //        'email': ['', [Validators.required]], 
    //        'phoneNumber': ['', [Validators.required]],
    //        'gender': ['', [Validators.required]]                                            
    //     });

  }

  ngOnInit() {
    var token = localStorage.getItem('authToken');
    if (!token)
      this._router.navigate(["login"]);

    this._editprofileService.editprofile()
      .subscribe((res) => {
        this.data = res.data;
        this.loading = false;
      });
  }



  revoke1() {
    this.authorizedd1 = false;
  }
  revoke2() {
    this.authorizedd2 = false;
  }
  revoke11() {
    this.authorizedd1 = true;
  }
  revoke22() {
    this.authorizedd2 = true;
  }
  usernamehide() {
    // alert("hi");
    this.profileusername = true;
  }
  usernameehide() {
    // alert("hi");
    this.profileusername = false;
  }

  changePrivate(val: any) {
    if (val == true) {
      this.data.private = 1;
    } else {
      this.data.private = 0;
    }
  }


  saveUser() {
    // console.log(this.data);
    function ValidateEmail(email: any) {
      var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
      return expr.test(email);
    }
    var profile = jQuery(".suggestion_image").attr("src");
    this.data.profilePicUrl = profile;
    var username_profile = jQuery(".username_profile").val();
    var bio_profile = jQuery(".bio_profile").val();
    if (bio_profile) {
      if (bio_profile.length <= 150) {
        this.bio_details = false;
      } else {
        this.bio_details = true;
        this.email_phone = false;
        this.saveuser = false;
        return;
      }
    } else {
      this.bio_details = false;
    }
    var email_profile = jQuery(".email_profile").val();
    if (!ValidateEmail(email_profile)) {
      this.email_phone = true;
      this.bio_details = false;
      this.saveuser = false;
      return;
    } else {
      this.email_phone = false;
    }
    var mobile_profile = jQuery(".mobile_profile").val();
    // //console.log(mobile_profile);
    if (mobile_profile) {
      if (jQuery.isNumeric(mobile_profile)) {
        if (mobile_profile.charAt(0) == '+') {
          if (mobile_profile.length != 13) {
            this.mobile_details = true;
            this.saveuser = false;
            return;
          } else {
            this.mobile_details = false;
            // this.bio_details =false;
            // this.email_phone =false; 
          }
        } else {
          if (mobile_profile.length != 10) {
            this.mobile_details = true;
            this.saveuser = false;
            return;
          } else {
            this.mobile_details = false;
            // this.bio_details =false;
            // this.email_phone =false; 
          }
        }
      } else {
        this.mobile_details = true;
        return;
      }
    } else {
      this.mobile_details = false;
    }
    this.websiteUrl = this.data.websiteUrl;
    // //console.log(username_profile+"aa"+bio_profile.length+"bb"+email_profile);
    if (username_profile && ValidateEmail(email_profile)) {
      this.saveuser = false;
      this.data = this.data;
      if (this.websiteUrl) {
        this.data.website = this.data.websiteUrl;
      }

      this._editprofileService.saveprofile(this.data)
        .subscribe((res) => {
          this.bufferprofile = true;
          setTimeout(() => {
            this.bufferprofile = false;
          }, 500);
          if (res.code == 200) {
            setTimeout(() => {
              this.saveuser = true;
            }, 500);

          }

        });
    }

  }

  removePhoto() {
    jQuery(".suggestion_image").attr("src", "");
    this.data.profilePicUrl = "";
    jQuery(".modal").modal("hide");
  }

  uploadImg(fileInput: any) {
    var input = fileInput.srcElement;
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        // $('.imgProfile').attr("src", e.target.result);
        // jQuery(".suggestion_image").attr("src", e.target.result);
        // $('#uploadImg').val(e.target.result);
        let img = e.target.result.split(",");
        this.uploadImgList(e.target.result);
      }
      reader.readAsDataURL(input.files[0]);
    }
  }

  uploadImgList(list: any) {
    jQuery(".loaderImg").show();
    jQuery(".modal").modal("hide");
    setTimeout(() => {
      jQuery(".loaderImg").hide();
    }, 2000);
    this._editprofileService.changePhoto(list)
      .subscribe(res => {
        if (res.code == 200) {
          jQuery(".suggestion_image").attr("src", res.mobileImage);
          setTimeout(() => {
            jQuery(".loaderImg").hide();
          }, 1000);
        } else {
          jQuery(".loaderImg").hide();
        }
        // this.url = res.mobileImage;
        // this.thumbnailImage = res.thumbnailImage;
        console.log("res", res);
      }
      )
  }



  changePassword() {
    // //console.log(this.data);
    this._editprofileService.savepasswordprofile({
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
      confirmPassword: this.confirmPassword
    })
      .subscribe((res) => {
        if (res.code == 200) {
          this.passwordsuccess = false;
          this.passwordolderror = true;
          this.passworderror = true;
        }
        if (res.code == 9158) {
          this.passwordolderror = false;
          this.passwordsuccess = true;
          this.passworderror = true;
        }
        if (res.code == 9159) {
          this.passworderror = false;
          this.passwordsuccess = true;
          this.passwordolderror = true;
        }
      });
  }




}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Home/profileedit/profile-edit.component.ts
 **/